import { useEffect } from 'react'
import { ErrorOutline } from '@mui/icons-material'
import { CircularProgress, Fab } from '@mui/material'
import { motion } from 'framer-motion'
import { INNER_PAGE_HEIGHT_WHEADER } from '@components/layout'
import { useAppDispatch } from '@redux/hooks'
import { ActionType } from '@submissions/submissions.reducer'
import * as css from './style'
import { TemplatesCard } from './templatesCard'
import { Toolbar } from './toolbar'
import { useTemplatesQuery } from './useTemplatesQuery'
import { useToolbar } from './useToolbar'
import { t } from '@lingui/core/macro'

const QueryError = () => (
  <section css={css.divStyle}>
    <Fab css={css.fabStyle} disabled>
      <ErrorOutline css={css.fileCopyOutlinedIconStyle} />
    </Fab>
    <h3>{t`Something went wrong.`}</h3>
  </section>
)

/**
 * Templates page.
 * - Templates are grouped by folder name.
 */
export const TemplatesByFolder = () => {
  const dispatch = useAppDispatch()
  const { data: templates, isInitialLoading: isLoading, error } = useTemplatesQuery()
  const { filteredTemplatesBySearch, onChangeFilter } = useToolbar({
    templates,
  })

  useEffect(() => {
    if (!templates) return

    dispatch({ type: ActionType.TEMPLATES_LOADED, payload: templates })
  }, [templates])

  if (isLoading) {
    return (
      <div css={css.divStyle} aria-label="loading templates">
        <CircularProgress color="primary" />
      </div>
    )
  }

  if (error) {
    return <QueryError />
  }

  return (
    <>
      <Toolbar onChangeFilter={onChangeFilter} />
      <motion.div
        className="Templates"
        key="templates"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1, transition: { duration: 0.15 } }}
        exit={{ opacity: 0, transition: { duration: 0.15 } }}
        style={{
          borderTop: '1px solid #e8e8e8',
          overflowY: 'scroll',
          height: INNER_PAGE_HEIGHT_WHEADER,
        }}
      >
        <TemplatesCard templates={filteredTemplatesBySearch} />
      </motion.div>
    </>
  )
}
